import { render } from "./SettingsTeamKeywords.vue?vue&type=template&id=557e8639"
import script from "./SettingsTeamKeywords.vue?vue&type=script&lang=js"
export * from "./SettingsTeamKeywords.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__